<template>
  <b-button
    v-bind="$attrs"
    v-on="$listeners"
    v-loading="$props.loading"
    :variant="$props.variant"
    :size="$props.size"
    :disabled="$props.disabled"
  >
    <slot />
  </b-button>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { BS_VARIANTS, BS_SIZES } from '@constants'

export default defineComponent({
  name: 'BaseButton',
  props: {
    loading: Boolean,
    disabled: Boolean,
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => BS_VARIANTS.includes(value)
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => BS_SIZES.includes(value)
    }
  },
  setup() {
    return {}
  }
})
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
}

.btn >>> .el-loading-spinner {
  width: 24px !important;
  margin-top: -12px !important;
}

.btn >>> .el-loading-spinner .circular {
  width: 24px !important;
  height: 24px !important;
}

.btn >>> .el-loading-spinner .path {
  stroke: #fff !important;
}

.btn-sm >>> .el-loading-spinner {
  width: 16px !important;
  margin-top: -8px !important;
}

.btn-sm >>> .el-loading-spinner .circular {
  width: 16px !important;
  height: 16px !important;
}
</style>
